import React, { Component } from 'react';
import ReactDOM from 'react-dom';


class HomeFooter extends Component {
  constructor(props){
    super(props);
    //console.log('Footer Props', this.props);
  }
  
  render() {
    let children = [];

    if (this.props.footer.fb) {
      children.push(
        <a key='ftfb' target="_blank" href={this.props.footer.fb}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <g>
              <path d="M28,0H4A4,4,0,0,0,0,4V28a4,4,0,0,0,4,4H16V21H12V16h4V12a6,6,0,0,1,6-6h4v5H24c-1.1,0-2-.1-2,1v4h5l-2,5H22V32h6a4,4,0,0,0,4-4V4A4,4,0,0,0,28,0Z" />
            </g>
          </svg>
        </a>
      );
    }
    if (this.props.footer.ig) {
      children.push(<a key='ftig' target="_blank" href={this.props.footer.ig}>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <g>
            <g>
              <path data-name="Path 810" d="M22,0H10A10,10,0,0,0,0,10V22A10,10,0,0,0,10,32H22A10,10,0,0,0,32,22V10A10,10,0,0,0,22,0Zm7,22a7.008,7.008,0,0,1-7,7H10a7.008,7.008,0,0,1-7-7V10a7.008,7.008,0,0,1,7-7H22a7.008,7.008,0,0,1,7,7Z" fill="#082427" />
            </g>
          </g>
          <g transform="translate(8 8)">
            <g>
              <path d="M136,128a8,8,0,1,0,8,8A8,8,0,0,0,136,128Zm0,13a5,5,0,1,1,5-5A5.007,5.007,0,0,1,136,141Z" transform="translate(-128 -128)" />
            </g>
          </g>
          <g transform="translate(23.534 6.334)">
            <g>
              <ellipse className="c" cx="1.066" cy="1.066" rx="1.066" ry="1.066" />
            </g>
          </g>
        </svg>
      </a>);
    }
    if (this.props.footer.twitter) {
      children.push(<a key='fttw' target="_blank" href={this.props.footer.twitter}>

        <svg xmlns="http://www.w3.org/2000/svg" width="80.95" height="65.915" viewBox="0 0 80.95 65.915">
          <defs>
            <clipPath>
              <rect width="80.95" height="65.915" fill="none"/>
            </clipPath>
          </defs>
          <g clip-path="url(#clip-path)">
            <path d="M0,58.488a33.941,33.941,0,0,0,24.378-6.835c-7.589-.685-12.644-4.511-15.49-11.6a18.879,18.879,0,0,0,7.391-.34,16.823,16.823,0,0,1-9.542-5.97,16.339,16.339,0,0,1-3.6-10.521,16.7,16.7,0,0,0,7.217,1.983C3.067,19.064,1.379,11.754,5.427,2.973,14.5,13.655,25.853,19.5,39.645,20.431c-.06-1.654-.2-3.226-.159-4.794A16.555,16.555,0,0,1,51.553.617,16.363,16.363,0,0,1,67.7,4.8a1.065,1.065,0,0,0,1.112.3,34.422,34.422,0,0,0,9.9-3.888,17.194,17.194,0,0,1-6.847,9.015,31.45,31.45,0,0,0,9.08-2.41,31.649,31.649,0,0,1-7.36,7.856,2.073,2.073,0,0,0-.9,1.977,47.185,47.185,0,0,1-4.84,21.735A46.31,46.31,0,0,1,50.309,59.122a45.149,45.149,0,0,1-18.075,6.343,49.344,49.344,0,0,1-16.928-.628A46.375,46.375,0,0,1,.361,58.761C.3,58.72.239,58.669,0,58.488" transform="translate(0 0)" fill="#fff"/>
          </g>
        </svg>
      </a>);
    }
    if (this.props.footer.youtube) {
      children.push(<a key='ftytb' target="_blank" href={this.props.footer.youtube}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.545 32">
          <g transform="translate(0 0)">
            <path d="M44.567,83.084c-1.263-2.246-2.633-2.659-5.423-2.816C36.358,80.079,29.35,80,23.279,80s-13.094.079-15.878.265c-2.784.16-4.157.57-5.431,2.819C.669,85.327,0,89.19,0,95.991v.023c0,6.772.669,10.665,1.969,12.884,1.274,2.246,2.644,2.653,5.428,2.842,2.787.163,9.8.259,15.881.259s13.079-.1,15.869-.256c2.79-.189,4.16-.6,5.423-2.842,1.312-2.22,1.975-6.112,1.975-12.884v-.023C46.546,89.19,45.882,85.327,44.567,83.084ZM17.455,104.727V87.273L32,96Z" transform="translate(0 -80)" />
          </g>
        </svg>
      </a>);
    }
    if (this.props.footer.tiktok) {
      children.push(<a key='fttt' target="_blank" href={this.props.footer.tiktok}>
      <svg xmlns="http://www.w3.org/2000/svg" width="143.966" height="165.916" viewBox="0 0 143.966 165.916">
        <defs>
          <clipPath id="clip-path">
           <rect id="Rectangle_1849" data-name="Rectangle 1849" width="143.966" height="165.916" fill="none"/>
          </clipPath>
        </defs>
        <g id="Group_560" data-name="Group 560" clip-path="url(#clip-path)">
          <path id="Path_977" data-name="Path 977" d="M102.737,0c.819,16.723,9.249,32.907,29.86,38.787,3.7,1.056,7.519,1.71,11.368,2.569V68.88a71.909,71.909,0,0,1-40.03-13.028c-.046.822-.1,1.333-.1,1.844-.048,18.859.211,37.725-.216,56.575-.461,20.364-9.778,36.048-27.906,45.3-20.126,10.274-39.7,7.993-57.318-6.3A48.5,48.5,0,0,1,.321,119.733C-2.885,89.3,18.347,66.86,43.313,62.507a44.836,44.836,0,0,1,16.067-.039,1.513,1.513,0,0,1,.986,1.046c-.027,9.7-.119,19.4-.207,29.095,0,.145-.1.289-.068.2a92,92,0,0,0-9.519-.643c-13.126.432-21.956,12.8-21.721,22.295.279,11.24,6.194,20.274,16.346,23.35a23.452,23.452,0,0,0,29.211-14.745c.883-2.384.808-5.2.819-7.819q.244-56.414.378-112.828c0-.806-.025-1.612-.039-2.418Z" transform="translate(0)" fill="#fff"/>
        </g>
      </svg>
      </a>);
    }
    return (
      <>
        <div className="home-footer">
          <div className="home-footer-top">
            <div className="hf-image">
              <img src={this.props.footer.avatar} />
            </div>
          </div>
          <div className="home-footer-bottom">
            <h5>Follow {this.props.name}</h5>
            <div className="hfb-icons">
              {children}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default HomeFooter;
